export { default as LabelTagging } from './LabelTaggingContainer.vue';
export { default as PartTag } from './PartTagContainer.vue';
export { default as AnnotationTag } from './AnnotationTagContainer.vue';
